import { ApiResponse, PartialFailureMeta } from "@/interfaces/api-response";
import Campaign from "@/interfaces/campaign.interface";
import { Template } from "@/interfaces/template.interface";
import { Artwork } from "@/interfaces/artwork.interface";
import CustomizationForm from "@/interfaces/customization-form.interface";
import { ItemView } from "@/interfaces/common.interface";
import apiClient from "@/utils/axios";

export interface CampaignDetail {
  campaign: Campaign;
  template: Template | null;
  artwork: Artwork | null;
  customizationForm: CustomizationForm | null;
  meta?: PartialFailureMeta;
}

interface GetManyCampaignsParams {
  page?: number;
  size?: number;
  search?: string;
  customizationFormId?: string;
  view?: ItemView;
  [key: string]: any;
}

const getMany = async (
  params: GetManyCampaignsParams,
): Promise<ApiResponse<Partial<Campaign>[]>> => {
  const response = await apiClient.get<ApiResponse<Partial<Campaign>[]>>(
    `/campaigns`,
    { params },
  );
  return response.data;
};

const getOne = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Campaign>>(
    `/campaigns/${id}`,
  );
  return response.data;
};

const getDetail = async (id: string) => {
  const response = await apiClient.get<ApiResponse<CampaignDetail>>(
    `/campaigns/${id}/detail`,
  );
  return response.data;
};

const updateOne = async (id: string, data: Partial<Campaign>) => {
  const response = await apiClient.put<Campaign>(`/campaigns/${id}`, data);
  return response.data;
};

const syncManual = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Campaign>>(
    `/campaigns/${id}/sync-manual`,
  );
  return response.data;
};

const getManyByCustomizationFormId = (formId: string) => {
  return getMany({
    customizationFormId: formId,
    size: 2000,
  });
};

const campaignApi = {
  getMany,
  getOne,
  getDetail,
  updateOne,
  syncManual,
  getManyByCustomizationFormId,
};

export default campaignApi;
